/**
 * Chess piece sprites — Cburnett set (Colin M.L. Burnett, GPLv2+; the
 * Wikipedia/lichess standard), fetched from lichess-org/lila. Inline SVG
 * assets instead of Unicode glyphs: iOS upgraded some glyphs to emoji and
 * Windows rendered them thin — same board looked different on every phone.
 * Small enough that Vite inlines them as data URIs.
 */
import bB from "../assets/pieces/bB.svg";
import bK from "../assets/pieces/bK.svg";
import bN from "../assets/pieces/bN.svg";
import bP from "../assets/pieces/bP.svg";
import bQ from "../assets/pieces/bQ.svg";
import bR from "../assets/pieces/bR.svg";
import wB from "../assets/pieces/wB.svg";
import wK from "../assets/pieces/wK.svg";
import wN from "../assets/pieces/wN.svg";
import wP from "../assets/pieces/wP.svg";
import wQ from "../assets/pieces/wQ.svg";
import wR from "../assets/pieces/wR.svg";

/** FEN piece letter (case = colour) → sprite URL. */
export const PIECE_SRC: Record<string, string> = {
  K: wK, Q: wQ, R: wR, B: wB, N: wN, P: wP,
  k: bK, q: bQ, r: bR, b: bB, n: bN, p: bP,
};
